import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = "/configuration";

export const fetchAllConfigurations = async () =>
  (await axiosInstance.get(BASE_URL, getAuthHeaders())).data;

export const fetchConfigurationsByAccountId = async (accountId) =>
  (
    await axiosInstance.get(
      `${BASE_URL}/account/${accountId}`,
      getAuthHeaders(),
    )
  ).data;

export const fetchConfigurationById = async (uuid) =>
  (await axiosInstance.get(`${BASE_URL}/${uuid}`, getAuthHeaders())).data;

export const fetchConfigurationByConfigId = async (configType, configId) =>
  (
    await axiosInstance.get(
      `${BASE_URL}/${configType}/${configId}`,
      getAuthHeaders(),
    )
  ).data;

export const fetchDefaultConfiguration = async ({
  configId,
  configType,
  type,
}) =>
  (
    await axiosInstance.get(`${BASE_URL}/default`, {
      ...getAuthHeaders(),
      params: { configId, configType, type },
    })
  ).data;

export const createConfiguration = async (data) =>
  (await axiosInstance.post(BASE_URL, data, getAuthHeaders())).data;

export const updateConfiguration = async (uuid, data) =>
  (await axiosInstance.put(`${BASE_URL}/${uuid}`, data, getAuthHeaders())).data;

export const deleteConfiguration = async (uuid) =>
  (await axiosInstance.delete(`${BASE_URL}/${uuid}`, getAuthHeaders())).data;

export const updateLLMConfiguration = async (uuid, data) =>
  (await axiosInstance.put(`${BASE_URL}/${uuid}/llm`, data, getAuthHeaders()))
    .data;

export const updateTranscriber = async (uuid, data) =>
  (
    await axiosInstance.put(
      `${BASE_URL}/${uuid}/transcriber`,
      data,
      getAuthHeaders(),
    )
  ).data;

export const updateVoice = async (uuid, data) =>
  (await axiosInstance.put(`${BASE_URL}/${uuid}/voice`, data, getAuthHeaders()))
    .data;

export const deleteNestedField = async (uuid, field) =>
  (await axiosInstance.delete(`${BASE_URL}/${uuid}/${field}`, getAuthHeaders()))
    .data;

export const setConfigurationAsDefault = async (uuid, type) =>
  (
    await axiosInstance.put(
      `${BASE_URL}/${uuid}/set-default`,
      {type},
      getAuthHeaders(),
    )
  ).data;
